export var COLUMN_MIN_WIDTH = 48;
export var TABLE_DEFAULT_WIDTH = 760;
export var TABLE_MAX_WIDTH = 1800;
export var FULL_WIDTH_EDITOR_CONTENT_WIDTH = 1800;
export var MAX_SCALING_PERCENT = 0.3;
export var MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION = 0.4;
// Used to calculate the width of a table using the Editor width
export var TABLE_EDITOR_MARGIN = 76;
var COMMENT_AK_EDITOR_CONTENT_AREA_PADDING = 20;
var COMMENT_PM_TABLE_RESIZING_PLUGIN_MARGIN = 12;
export var TABLE_OFFSET_IN_COMMENT_EDITOR = 2 * (COMMENT_AK_EDITOR_CONTENT_AREA_PADDING + COMMENT_PM_TABLE_RESIZING_PLUGIN_MARGIN);